import React from 'react'
import { Outlet } from 'react-router-dom'
import Footer from './Footer'
import Header from './Header'
import FloatingWhatsapp from './floatingwhatsapp/FloatingWhatsapp'


const Layout = () => {
  return (
    <div>
        <Header />
        <Outlet />
        <FloatingWhatsapp />
        <Footer />
       
      
    </div>
  )
}

export default Layout
